import { render, staticRenderFns } from "./MainWireInfoCard.vue?vue&type=template&id=441202ed"
import script from "./MainWireInfoCard.vue?vue&type=script&lang=js"
export * from "./MainWireInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports